var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ds-label",attrs:{"for":_vm.forId}},[_c('DSTextElement',{staticClass:"ds-label__text",attrs:{"color":_vm.textColor}},[(_vm.isDefaultSlot)?[_vm._t("default")]:[_vm._v(" "+_vm._s(_vm.text)+" ")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }